import React from 'react'

const SvgSearch = props => (
  <svg viewBox='0 0 20 20' {...props}>
    <path
      d='M14.5 13.1c2.5-3.1 2.2-7.7-.6-10.6-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3c2.9 2.9 7.4 3.1 10.6.7l5 5c.4.4 1 .4 1.4 0s.4-1 0-1.4l-5.1-5zm-2-.7c1.2-1.2 1.7-2.6 1.7-4.2 0-1.7-.6-3.1-1.8-4.2-1.2-1.2-2.6-1.8-4.2-1.8-1.7 0-3.1.6-4.2 1.8S2.2 6.5 2.2 8.2s.6 3.1 1.8 4.2c1.2 1.2 2.6 1.8 4.2 1.8s3.1-.6 4.3-1.8c-.1 0-.1 0 0 0-.1 0-.1 0 0 0z'
      fillRule='evenodd'
      clipRule='evenodd'
      fill='#fff'
    />
  </svg>
)

export default SvgSearch
